export default __webpack_public_path__ + "static/jo-manhattan-thumbnail-690e6c9bc3d9bdd69060c626599ffb08.jpg";